/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */

import React from "react";
import { StoryWrapper } from "../story-wrapper";

export const LiveBlogStory = props => {
  return <StoryWrapper {...props} />;
};

LiveBlogStory.defaultProps = {
  storyStoreField: "story",
  storyPageType: "liveBlog-story"
};
export default LiveBlogStory;
